import Vue from 'vue'
import '@/assets/style/reset.css'
import '@/assets/style/border.css'
import {StrDate, showStrDateTime, showStrDate, showStrTime, selectWeekDay, getCurrentMonthLast, addMonth, addDay} from './util/handleDateTime'
import {encryptByAES, decryptByAES} from './util/EncryptionAndDecryption'
import {getPinKey} from './util/makePostData'
import ElementUI from 'element-ui'
import {AccessControlApi} from '@/request/AccessControl/api'
import {SysManageApi} from './request/SysManage/sys_manage_api'
import {PaymentApi} from './request/Payment/payment_api'
import {CommonApi} from '@/request/common_api'
import {ConsumeApi} from '@/request/Consume/consume_api'
import {OrderApi} from '@/request/Order/order_api'
import {ApplyBasicApi} from './request/ApplyBasic/apply_basic_api'
import {ReportApi} from './request/Consume/report_api'
import {ProgramApi} from './request/Program/program_api'
import {downLoadFile} from './util/downLoadFile'
import {getConsumeDropDownList} from './util/ConsumeDropDownList'
import {getOrderDropDownList} from './util/OrderDropDownList'
import {getProgramDropDownList} from './util/ProgramDropDownList'
import {getHeight} from './util/getHeight'
import {getCommDropDownList} from './util/CommDropDownList'
import {getPaymentDropDownList} from './util/PaymentDropDownList'
import {checkPermission, rights} from './util/handlePermission'
import {handle} from './util/handleFunc'
import {getType} from './util/handlePullDownList'
import '@/assets/iconfont/iconfont.css'
import '@/assets/iconfont/iconfont.js'
import '@/assets/iconfont/renyuan-iconfont.js'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import '@/assets/style/globalSpace.css'
import './util/dialog'

ElementUI.Dialog.props.closeOnClickModal.default = false
Vue.prototype.$encryptByAES = encryptByAES
Vue.prototype.$decryptByAES = decryptByAES
Vue.prototype.$getPinKey = getPinKey
Vue.prototype.$addMonth = addMonth
Vue.prototype.$addDay = addDay
Vue.prototype.$strDate = StrDate
Vue.prototype.$downLoadFile = downLoadFile
Vue.prototype.showStrDate = showStrDate
Vue.prototype.showStrTime = showStrTime
Vue.prototype.showStrDateTime = showStrDateTime
Vue.prototype.selectWeekDay = selectWeekDay
Vue.prototype.getCurrentMonthLast = getCurrentMonthLast
Vue.prototype.checkPermission = checkPermission
Vue.prototype.rights = rights
Vue.prototype.$handle = handle
Vue.prototype.getType = getType
Vue.prototype.$accessApi = AccessControlApi
Vue.prototype.$commonApi = CommonApi
Vue.prototype.$sysManageApi = SysManageApi
Vue.prototype.$consumeApi = ConsumeApi
Vue.prototype.$paymentApi = PaymentApi
Vue.prototype.$orderApi = OrderApi
Vue.prototype.$applyBasicApi = ApplyBasicApi
Vue.prototype.$reportApi = ReportApi
Vue.prototype.$programApi = ProgramApi
Vue.prototype.$getConsumeDropDownList = getConsumeDropDownList
Vue.prototype.$getCommDropDownList = getCommDropDownList
Vue.prototype.$getPaymentDropDownList = getPaymentDropDownList
Vue.prototype.$getOrderDropDownList = getOrderDropDownList
Vue.prototype.$getProgramDropDownList = getProgramDropDownList
Vue.prototype.$getHeight = getHeight
Vue.prototype.headClass = () => {
  return 'text-align: center;'
}

Vue.use(ElementUI, {size: 'small', fontsize: '14px'})
Vue.prototype.$loading = ElementUI.Loading.service
Vue.prototype.$msgbox = ElementUI.MessageBox
Vue.prototype.$alert = ElementUI.MessageBox.alert
Vue.prototype.$confirm = ElementUI.MessageBox.confirm
Vue.prototype.$prompt = ElementUI.MessageBox.prompt
Vue.prototype.$notify = ElementUI.Notification
Vue.prototype.$message = ElementUI.Message
// import { Button } from 'element-ui'
//
// Vue.use(Button)
// // Vue.use(NavMenu)



// WEBPACK FOOTER //
// ./src/plugin_conf.js